
export class MaintenanceVariables {

    public from:Date|undefined|null;
    public until:Date|undefined|null;

    constructor(data = undefined) {
        if(data === undefined)
        {
            return;
        }
        Object.keys(data).forEach(key => {
            this[key] = data[key];
        })

        if(this.from !== undefined && this.from !== null)
        {
            this.from = new Date(this.from);
        }

        if(this.until !== undefined && this.until !== null)
        {
            this.until = new Date(this.until);
        }
    }

    public serializeData()
    {
        return {...this};
    }
}


